import React, { forwardRef } from 'react'
import { DatePickerRange } from '@ow/comps'
import locale from '@ow/comps/locale/zh-CN'

const Render = function ({ opts = {}, value = {}, style, onChange }) {
  const { showTime = false, showMonth, monthType } = opts
  return (
    <DatePickerRange
      dateRangeId={opts.slug}
      ranges={[
        {
          startDate: value && value.startDate,
          endDate: value && value.endDate,
          key: 'selection',
        },
      ]}
      placeholder={opts.hint || `请选择${opts.title}`}
      locale={locale}
      onChange={(date) => {
        const { startDate, endDate } = date[0]
        if (startDate !== endDate) {
          onChange({
            startDate,
            endDate:
              showTime || showMonth
                ? endDate
                : new Date(endDate.getTime() + 24 * 60 * 60 * 1000 - 1),
          })
        }
        if (!startDate && !endDate) {
          onChange({
            startDate,
            endDate,
          })
        }
      }}
      inputStyle={{
        ...style,
      }}
      showTime={showTime}
      showMonth={showMonth}
      monthType={monthType}
    />
  )
}

export default forwardRef(Render)
